import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Paper, Grid } from '@mui/material';

// Re-export common styles
export { FormPageContainer, FormHeader, FormSubHeader, StyledForm, SubmitButton, ButtonGroupContainer, SectionContainer, AddButton, RemoveButton, RadioGroupContainer, StyledRadioGroup, BackButton } from './ChildrenTrustForm.styles'; // Reusing from ChildrenTrustForm

// Specific styles
export const EstateSectionHeader = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
}));

export const EstateControlsContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

export const EstateButtonsGroup = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    justifyContent: 'center', // Or 'flex-start'
    marginTop: theme.spacing(1),
}));

export const EstateTypeButton = styled(Button)(({ theme }) => ({
   flex: '1 1 140px', // Allow buttons to grow but have a base size
   minWidth: '140px',
   padding: theme.spacing(1, 1.5),
   fontSize: '14px',
   textTransform: 'none', // Prevent uppercase default
}));

export const EstateItemsGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const EstateItemPaper = styled(Paper)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[50], // Slightly different background
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2), // Gap between fields inside the item
}));

export const EstateItemHeader = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(1),
    fontWeight: 500,
}));


export const BeneficiarySelectionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%', // Ensure it takes full width within its container
}));

export const RemainderBeneficiaryPaper = styled(Paper)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[50],
    marginBottom: theme.spacing(2.5),
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
}));

export const NoItemsTypography = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),
}));

export const PercentageHelperBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1.5),
  backgroundColor: error ? theme.palette.error.light : theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  borderLeft: `4px solid ${error ? theme.palette.error.main : theme.palette.primary.main}`,
  transition: 'all 0.3s ease',
  '& p': {
      margin: 0,
      color: error ? theme.palette.error.dark : theme.palette.primary.dark,
      fontWeight: 'bold',
  }
}));